export function onChange(model) {
  return (state) => ({
    ...state,
    form: {
      ...state.form,
      [model.name]: {
        ...state.form[model.name],
        ...model,
      },
    },
  })
}

export default function Model(name, value = '', type = 'text', opts = {}) {
  switch (type) {
    case 'checkbox':
      return {
        name,
        checked: !!value,
        ...opts,
      }

    case 'select':
      return {
        name,
        value,
        type,
        invalid: false,
        valid: undefined,
        dirty: false,
        pristine: true,
        touched: false,
        untouched: true,
        pending: false,
        error: {},
        ...opts,
      }

    default:
      return {
        value,
        name,
        type,
        invalid: false,
        valid: undefined,
        dirty: false,
        pristine: true,
        touched: false,
        untouched: true,
        pending: false,
        error: {},
        ...opts,
      }
  }
}



// WEBPACK FOOTER //
// ./src/lib/Model.js